import React from "react";
import { FaCrown, FaBook, FaSitemap, FaProjectDiagram, FaShieldAlt, FaRocket } from "react-icons/fa";
import MonoButton from "../../kits/DesignKit/MonoButton";

const ZenPostDocStudioFeaturesSection = ({
  id = "docstudio",
  badge = "Doc Studio Add-on",
  title = "Doc Studio",
  titleAccent = "als Upgrade",
  subtitle = "Freischaltbares Paket für Dokumentation, Project Analysis und Data Room – unabhängig von Free/Pro.",
  cards = null,
  primaryCtaText = "Doc Studio freischalten",
  onPrimaryCta = null,
  secondaryCtaText = "Preise ansehen",
  onSecondaryCta = null,
}) => {
  const defaultCards = [
    {
      icon: <FaBook />,
      title: "README & Docs",
      description: "Generiere verlässliche Projekt-Dokumente aus Code + Kontext.",
    },
    {
      icon: <FaSitemap />,
      title: "Project Context Wizard",
      description: "Source of Truth statt Vermutungen – klare Fakten, klare TODOs.",
    },
    {
      icon: <FaProjectDiagram />,
      title: "Automatic Project Scan",
      description: "Erkennt Struktur, Dependencies und Bausteine automatisch (kein Raten).",
    },
    {
      icon: <FaShieldAlt />,
      title: "Investor-ready Data Room",
      description: "Ordnung, Nachweise, Checklisten – als exportierbares Set.",
    },
    {
      icon: <FaCrown />,
      title: "Pro Feature Toggle",
      description: "Doc Studio ist separat buchbar: monatlich oder lifetime.",
    },
    {
      icon: <FaRocket />,
      title: "Für Shipping gemacht",
      description: "Docs sind sofort nutzbar – nicht nur Text, sondern verwertbar.",
    },
  ];

  const list = cards || defaultCards;

  return (
    <section id={id} className="py-16 sm:py-20 px-4 bg-[transparent]">
      <div className="max-w-6xl mx-auto text-center">
        <div className="inline-flex items-center rounded-full border border-brand px-3 py-1 text-xs text-[#EFEBDC]">
          {badge}
        </div>

        <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold text-brand">
          {title} <span className="text-[#EFEBDC]">{titleAccent}</span>
        </h2>

        <p className="mt-3 text-base sm:text-lg text-[#EFEBDC] max-w-3xl mx-auto">
          {subtitle}
        </p>

        {/* Cards */}
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 text-left">
          {list.map((c) => (
            <div
              key={c.title}
              className="rounded-2xl border border-brand  p-6 shadow-lg shadow-slate-950/40"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-transparent border border-brand text-brand text-xl">
                {c.icon}
              </div>
              <h3 className="mt-5 text-xl font-semibold text-brand">{c.title}</h3>
              <p className="mt-2 text-sm text-[#EFEBDC]">{c.description}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
     
      </div>
    </section>
  );
};

export default ZenPostDocStudioFeaturesSection;
